import { action, computed, makeObservable, observable } from 'mobx';

import {
  ShipmentOriginData,
  ShipmentOriginIds,
  ShipmentOriginType,
  SHIPMENT_ORIGIN_TO_IDS,
  IDS_TO_SHIPMENT_ORIGIN_MAP,
  SHIPMENT_ORIGIN_IS_PHARMACY,
} from 'jsx/constants/shipments';

import { Constructor } from './types';

const Location = <T extends Constructor>(superclass: T) => {
  class LocationClass extends superclass {
    constructor(...args: any[]) {
      super(...args);
      makeObservable(this);
    }

    @observable
    location: ShipmentOriginData | null = null;

    @action
    setLocationFromId = (location: ShipmentOriginIds) => {
      this.location = {
        id: location,
        abbreviation: IDS_TO_SHIPMENT_ORIGIN_MAP[location],
      };
    };

    @action
    setLocationFromAbbreviation = (location: ShipmentOriginType) => {
      this.location = {
        id: SHIPMENT_ORIGIN_TO_IDS[location],
        abbreviation: location,
      };
    };

    @computed
    get isPharmacy(): boolean {
      return (
        this.location != null &&
        SHIPMENT_ORIGIN_IS_PHARMACY[this.location.abbreviation]
      );
    }
  }

  return LocationClass;
};

export default Location;
